function init(){
const body = document.body;
const menus = {
	contact: {
		triggerClass:'header__contact',
		contentClass: 'header__contact-list',
	},
	headerLanguage: {
		triggerClass:'header__language',
		contentClass: 'header__language-list',
	},
	headerMenu: {
		triggerClass:'header__menu',
		contentClass: 'header__menu-body',
	},
	footerLanguage: {
		triggerClass:'footer__language',
		contentClass: 'footer__language-list',
	},
	footerSubmenus: {
		triggerClass:'footer__card-menu-item',
		contentClass: 'footer__card-sublist',
	},
}
const tabs = {
	links: {
		triggerClass:'header__links',
	},
	contacts: {
		triggerClass:'header__contacts',
	},
	footer: {
		triggerClass:'footer__card-title',
		contentClass: 'footer__card-list',
	},
}
const mores = {
	footer: {
		triggerClass: 'footer__more',
		hideContentClass: 'footer__card-list--hidden',
		showedListLength: 11,
	},
}
const closeAllMenus = closeMenus(menus);
const showModalById = showModal({
	closeButtonClass: 'popup__modal-close',
	modalContentClass: 'modal',
	visibleClass: 'modal__active',
	modalWrapperClass: 'modal-overlay'
});
const hideCurrentModal = hideModal({
	visibleClass: 'modal__active',
	modalWrapperClass: 'modal-overlay'
});
const anchorActions = {
	openModal: ({ openModal }) => {
		closeAllMenus();
		showModalById(openModal);
	},
}
// const buttonActions = {
// 	setPage: ({ setPage }) => {
// 		setReviewsSliderPage({ setPage });
// 	},
// 	setInput: ({ setInput, value }) => {
// 		if (!value) {
// 			return;
// 		}
//
// 		switch (setInput) {
// 			case 'rating':
// 				const isIncorrectValue = isNaN(value) || value < 1 || value > 5;
// 				const rating_score = isIncorrectValue ? 5 : Number(value);
// 				const ratingInput = document.getElementById('rating');
//
// 				if (!ratingInput) {
// 					return;
// 				}
//
// 				ratingInput.dataset.value = value;
// 				ratingInput.value = rating_score;
//
// 				return;
// 			default:
// 				return;
// 		}
// 	}
// }
// const timeLabelElements = getCountryTimeLabelElements([
// 	'header__contact-time',
// 	'header__contacts-time',
// 	'footer__card-time',
// ]);
const mainStyle = document.getElementById('main_style');
const mainScrypt = document.getElementById('main_script');
const loadLibsOnce = runOnce(loadLibs);

for (const prop in menus) {
	body.addEventListener('click', toggleMenu(menus[prop], closeAllMenus));
}

for (const prop in tabs) {
	body.addEventListener('click', toggleTab(tabs[prop]));
}

for (const prop in mores) {
	const moreElements = document.getElementsByClassName(mores[prop].triggerClass)
	const toggleMoreCb = toggleMore(mores[prop])

	for (const moreElement of moreElements) {
		toggleMoreCb({ target: moreElement });
	}

	body.addEventListener('click', toggleMoreCb);
}

setCooperateFormHandlers();
setToDirectorFormHandlers();
setLeaveReviewFormHandlers();
// setCountryTimeLabelOffsetAndTime(timeLabelElements);
setRefreshCountryTimeInterval();
loadGoogleAnalytics();
body.addEventListener('click', (e) => {
	const { target } = e

	for (const prop in menus) {
		const { triggerClass, contentClass } = menus[prop];
		const menuTrigger = target.closest('.' + triggerClass);
		const menuContent = target.closest('.' + contentClass);

		if (menuTrigger || menuContent) {
			return;
		}
	}

	closeAllMenus();
});
// body.addEventListener('click', createButtonClickHandler(buttonActions));
body.addEventListener('click', buttonClickHandler);
body.addEventListener('click', createAnchorClickHandler(anchorActions));
body.addEventListener('click', liClickHandler);
window.addEventListener('click', loadLibsOnce, { once: true });
window.addEventListener('scroll', loadLibsOnce, { once: true });
window.addEventListener('mousemove', loadLibsOnce, { once: true });
window.addEventListener('touchstart', loadLibsOnce, { once: true });

removePreviewAndLoadSwiperStyles();

const reviewPageSlider = new Swiper(".reviews__slider-main", {
	slidesPerView: 1,
	navigation: {
		disabledClass: '.reviews__arrow--disabled',
		nextEl: '.reviews__arrow--next',
		prevEl: '.reviews__arrow--prev',
	},
	pagination: {
		el: ".swiper-pagination",
		clicable: true,
	},
	breakpoints: {
		320: {
			grid: {
				fill: 'row',
				rows: 1
			},
		},
		768: {
			grid: {
				fill: 'row',
				rows: 1
			},
		},
		993: {
			grid: {
				fill: 'row',
				rows: 1
			},
		},
		1201: {
			grid: {
				fill: 'row',
				rows: 2
			},
		}
	},
});
const getReviewActiveIndexAndPagesCount = getSwiperOptions(reviewPageSlider);
const updatePagePagination = createPagePaginationUpdater({
	paginationPagesClass: 'reviews__pages',
	pageClass: 'reviews__page',
	prevSvgImg: `
		<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g id="Chevron-left">
				<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M19.3601 5.53821C19.7532 5.87517 19.7988 6.46702 19.4618 6.86013L12.4848 15L19.4618 23.1399C19.7988 23.533 19.7532 24.1249 19.3601 24.4618C18.967 24.7988 18.3752 24.7533 18.0382 24.3601L10.5382 15.6101C10.2373 15.259 10.2373 14.741 10.5382 14.3899L18.0382 5.6399C18.3752 5.24678 18.967 5.20126 19.3601 5.53821Z" fill="#E0DAFF"></path>
			</g>
	  	</svg>
	`,
	nextSvgImg: `
		<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    		<g id="Chevron-right">
    			<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M10.6399 5.53821C11.033 5.20126 11.6249 5.24678 11.9618 5.6399L19.4618 14.3899C19.7627 14.741 19.7627 15.259 19.4618 15.6101L11.9618 24.3601C11.6249 24.7533 11.033 24.7988 10.6399 24.4618C10.2468 24.1249 10.2013 23.533 10.5382 23.1399L17.5153 15L10.5382 6.86013C10.2013 6.46702 10.2468 5.87517 10.6399 5.53821Z" fill="#221B37"></path>
    		</g>
  		</svg>
	`,
});
const setReviewsSliderPage = setPage(reviewPageSlider, 'reviews__cards');
reviewPageSlider.on('activeIndexChange', (swiper) => {
	setDisabledState(swiper, 'reviews__arrow');
});
updatePagePagination();
window.addEventListener('resize', updatePagePagination);

function setDisabledState(swiper, arrowClass, modifier = '--disabled') {
	const arrows = document.getElementsByClassName(arrowClass);
	const prev = arrows[0];
	const next = arrows[arrows.length - 1];

	if (!prev || !next) {
		return;
	}

	removeClassFromElement(prev, arrowClass, modifier);
	removeClassFromElement(next, arrowClass, modifier);

	if (swiper.isBeginning) {
		addClassToElement(prev, arrowClass, modifier);
	}
	if (swiper.isEnd) {
		addClassToElement(next, arrowClass, modifier);
	}
}
function liClickHandler (e){
	const li =  e.target.closest('li');

	if (!li) {
		return;
	}

	const { dataset } = li;
	const actions = {
		setPage: ({ setPage }) => {
			setReviewsSliderPage({ setPage });
		},
	}
	let isActionExists = false;

	for (const action in actions) {
		if (dataset.hasOwnProperty(action)) {
			isActionExists = true;
			actions[action](dataset);
		}
	}

	if (isActionExists) {
		e.preventDefault();
	}
}
function getSwiperOptions(swiper) {
	return () => {
		const isDesktop = window.innerWidth >= 1200;
		const type = isDesktop ? 'desktop' : 'mobile';
		const rows = isDesktop ? 2 : 1;
		const pages = swiper.slides.length / rows;

		return {
			activeIndex: swiper.activeIndex + 1,
			pagesCount: pages,
			type
		};
	}
}
function createPagePaginationUpdater ({ paginationPagesClass, pageClass, prevSvgImg, nextSvgImg }) {
	const disabledModifier = '--disabled';
	const selectedModifier = '--selected';
	const attributeName = 'data-set-page';
	const createPages = (length, activeIdx, type = "desktop") => {
		const substract = type === 'desktop' ? 0 : 1;
		const lengthLimit = type === 'desktop' ? 7 : 5;
		const dynamicLimit = lengthLimit - 2;
		const [prevArrow, nextArrow] = (new Array(2)).fill(0)
			.map(_ => document.createElement('li'));
		const [prevA, nextA] = (new Array(2)).fill(0)
			.map(_ => document.createElement('a'));
		const lis = [];

		prevA.innerHTML = prevSvgImg;
		prevA.href = '#';
		prevA.setAttribute('aria-label', 'Previous page');
		prevArrow.classList.add(pageClass);
		prevArrow.setAttribute(attributeName, 'prev');
		prevArrow.append(prevA);
		nextA.innerHTML = nextSvgImg;
		nextA.href = '#';
		nextA.setAttribute('aria-label', 'Next page');
		nextArrow.classList.add(pageClass);
		nextArrow.setAttribute(attributeName, 'next');
		nextArrow.append(nextA);

		if (activeIdx === 1) {
			prevArrow.classList.add(`${pageClass}${disabledModifier}`);
		}
		if (activeIdx === length) {
			nextArrow.classList.add(`${pageClass}${disabledModifier}`);
		}
		if (length <= lengthLimit) {
			for (let i = 0; i < length; i++) {
				const index = i + 1;
				const li = document.createElement('li');
				const a = document.createElement('a');

				a.textContent = `${index}`;
				a.href = '#';
				a.setAttribute('aria-label', `${index} page`);
				li.append(a);
				li.setAttribute(attributeName, `${index}`);
				li.classList.add(pageClass);

				if (index === activeIdx) {
					li.classList.add(`${pageClass}${selectedModifier}`);
				}

				lis.push(li);
			}

			return [prevArrow, ...lis, nextArrow];
		}

		const [firstLi, lastLi, fakeLiOne, fakeLiTwo] = (new Array(4)).fill(0)
			.map(_ => document.createElement('li'));
		const [firstA, lastA, fakeAOne, fakeATwo] = (new Array(4)).fill(0)
			.map(_ => document.createElement('a'));

		firstA.textContent = `1`;
		firstA.href = '#';
		firstA.setAttribute('aria-label', `1 page`);
		firstLi.append(firstA);
		firstLi.setAttribute(attributeName, '1');
		firstLi.classList.add(pageClass);
		lastA.textContent = `${length}`;
		lastA.href = '#';
		lastA.setAttribute('aria-label', `${length} page`);
		lastLi.append(lastA);
		lastLi.setAttribute(attributeName, `${length}`);
		lastLi.classList.add(pageClass);
		fakeAOne.textContent = `...`;
		fakeAOne.href = '#';
		fakeAOne.setAttribute('aria-label', `...`);
		fakeLiOne.append(fakeAOne);
		fakeLiOne.classList.add(pageClass);

		if (activeIdx === 1) {
			firstLi.classList.add(`${pageClass}${selectedModifier}`);
		}
		if (activeIdx === length) {
			lastLi.classList.add(`${pageClass}${selectedModifier}`);
		}
		if (activeIdx < dynamicLimit + substract) {
			for (let i = 1; i < dynamicLimit; i++) {
				const index = i + 1;
				const li = document.createElement('li');
				const a = document.createElement('a');

				a.textContent = `${index}`;
				a.href = '#';
				a.setAttribute('aria-label', `${index} page`);
				li.append(a);
				li.setAttribute(attributeName, `${index}`);
				li.classList.add(pageClass);

				if (index === activeIdx) {
					li.classList.add(`${pageClass}${selectedModifier}`);
				}

				lis.push(li);
			}

			return [prevArrow, firstLi, ...lis, fakeLiOne, lastLi, nextArrow];
		} else if (activeIdx > length - dynamicLimit + 1 - substract) {
			for (let i = length - dynamicLimit; i < length - 1; i++) {
				const index = i + 1;
				const li = document.createElement('li');
				const a = document.createElement('a');

				a.textContent = `${index}`;
				a.href = '#';
				a.setAttribute('aria-label', `${index} page`);
				li.append(a);
				li.setAttribute(attributeName, `${index}`);
				li.classList.add(pageClass);

				if (index === activeIdx) {
					li.classList.add(`${pageClass}${selectedModifier}`);
				}

				lis.push(li);
			}

			return [prevArrow, firstLi, fakeLiOne, ...lis, lastLi, nextArrow];
		} else {
			for (let i = activeIdx - 2 + substract; i <= activeIdx - substract; i++) {
				const index = i + 1;
				const li = document.createElement('li');
				const a = document.createElement('a');

				a.textContent = `${index}`;
				a.href = '#';
				a.setAttribute('aria-label', `${index} page`);
				li.append(a);
				li.setAttribute(attributeName, `${index}`);
				li.classList.add(pageClass);

				if (index === activeIdx) {
					li.classList.add(`${pageClass}${selectedModifier}`);
				}

				lis.push(li);
			}

			fakeATwo.textContent = `...`;
			fakeATwo.href = '#';
			fakeATwo.setAttribute('aria-label', `...`);
			fakeLiTwo.append(fakeATwo);
			fakeLiTwo.classList.add(pageClass);

			return [prevArrow, firstLi, fakeLiOne, ...lis, fakeLiTwo, lastLi, nextArrow];
		}
	}
	const pagesBlock = document.getElementsByClassName(paginationPagesClass)[0];
	
	return () => {
		const { activeIndex, pagesCount, type } = getReviewActiveIndexAndPagesCount()

		pagesBlock.innerHTML = '';
		pagesBlock.append(...createPages(pagesCount, activeIndex, type));
	}
}
function setPage (swiper, swiperWrapperClass) {
	const swiperWrapper = document.getElementsByClassName(swiperWrapperClass)[0];

	return  ({ setPage }) => {
		const isPreventScroll = (swiper.isBeginning && setPage === 'prev')
			|| (swiper.isEnd && setPage === 'next');
		const speed = 400;

		switch (setPage) {
			case 'prev':
				swiper.slidePrev(speed);
				break;
			case 'next':
				swiper.slideNext(speed);
				break;
			case 'loop':
				if (swiper.isEnd) {
					swiper.slideTo(0, speed);
				} else {
					swiper.slideNext(speed);
				}
				break;
			default:
				swiper.slideTo(parseInt(setPage) - 1, speed);
				break;
		}

		updatePagePagination();

		if (swiperWrapper && !isPreventScroll) {
			scrollToElement(swiperWrapper, speed * 2);
		}
	}
}

function loadItiLib (showLoader = false) {
	const loaderId = 'loader-modal';

	if (showLoader) {
		showModalById(loaderId);
	}
	insertStyleLink(labels.baseUrl + 'libs/intlTelInput/intl-tel-input.min.css', mainStyle)
		.then((res) => insertScript(labels.baseUrl + 'libs/intlTelInput/intl-tel-input.min.js', mainScrypt))
		.then((res) => insertScript(labels.baseUrl + 'libs/intlTelInput/utils.min.js', mainScrypt))
		.then((res) => {
			const loader = document.getElementById(loaderId);
			// const default_country_code = 'us';
			const setCountryCode = (country) => {
				intlTelInput(document.getElementById('cooperate_phone'), {
					autoHideDialCode: false,
					autoPlaceholder: 'aggressive',
					initialCountry: 'auto',
					separateDialCode: true,
					formatOnDisplay: false,
					preferredCountries: [
						'ua',
						'us'
					],
					customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
						return '' + selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
					},
					geoIpLookup: cb => cb(country),
				});
				intlTelInput(document.getElementById('to_director_phone'), {
					autoHideDialCode: false,
					autoPlaceholder: 'aggressive',
					initialCountry: 'auto',
					separateDialCode: true,
					formatOnDisplay: false,
					preferredCountries: [
						'ua',
						'us'
					],
					customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
						return '' + selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
					},
					geoIpLookup: cb => cb(country),
				});
			}

			getCountryCode().then(setCountryCode);
			// sendRequest('https://ipapi.co/json')
			// 	.then((res) => res.json())
			// 	.then(({ country_code }) => {
			// 		setCountryCode(country_code || default_country_code)
			// 	})
			// 	.catch(e => {
			// 		setCountryCode(default_country_code)
			// 	});

			if (showLoader && loader && loader.classList.contains('modal__active')) {
				hideCurrentModal({ target: loader });
			}
		});
}
function loadLibs (e) {
	loadItiLib();
	// setLanguagesAndLinks([
	// 	...document.getElementsByClassName('header__language-list'),
	// 	...document.getElementsByClassName('footer__language-list'),
	// ]);
}

function setLeaveReviewFormHandlers () {

	const leaveReviewForm = document.getElementById('review__form');

	if (!leaveReviewForm) {
		return;
	}

	const checkInputValue = checkInput({ groupClass: 'leave-review__form-group' });
	const hideInputError = hideError({ groupClass: 'leave-review__form-group' });
	const tags = [ 'INPUT', 'TEXTAREA' ];

	for (const element of leaveReviewForm.elements) {
		const { tagName, name } = element;
		const [ _, fieldName ] = name.split('_')

		if (tags.includes(tagName)) {
			savePlaceholder(element);
			element.addEventListener('focus', hideInputError);
			element.addEventListener('focus', hidePlaceholder);
			element.addEventListener('blur', checkInputValue);
			element.addEventListener('blur', showPlaceholder);
		}

		if (['name', 'lastname'].includes(fieldName)) {
			element.addEventListener('input', modifyValueToUpperCase);
		}
	}

	leaveReviewForm.addEventListener('submit', async (e) => {
		e.preventDefault();
		const body = validateForm(e.target);

		if (!body.isValid) {
			body.errorInputs.forEach(input => checkInputValue({ target: input }));

			return;
		}

		showModalById('loader-modal');
		sendRequestAndSaveToken('/api/create_review', {
			method: 'POST', body: JSON.stringify({
				first_name: body.reviewer_name,
				last_name: body.reviewer_lastname,
				message: body.message,
				rating: body.rating,
				url: window.location.pathname || '/',
			})
		}).then(({ response }) => {
			const loader = document.getElementById('loader-modal');

			hideCurrentModal({ target: loader });
			hideCurrentModal(e);

			if (!response || !response.success) {
				showModalById('error-feedback-modal');

				return;
			}

			selectedRatingButton = null;
			updateReviewRating(selectedRatingButton);

			// const { request_id, success, error_text } = response;

			// console.log({ success, error_text, request_id });

			showModalById('success-feedback-modal');
			e.target.reset();
		}).catch(e => showModalById('error-modal'));
	});
}

function modifyValueToUpperCase (e) {
	// const { target } = e;

	// target.value = target.value.toUpperCase();
	let value_arr = this.value.split('');
	this.value = value_arr.map(item => item.toUpperCase()).join('')
}


function buttonClickHandler (e) {
	const button = e.target.closest('button[type="button"]');
	const actions = {
		setPage: ({ setPage }) => {
			setReviewsSliderPage({ setPage });
		},
		setInput: ({ setInput, value }) => {
			if (!value) {
				return;
			}

			switch (setInput) {
				case 'rating':
					const isIncorrectValue = isNaN(value) || value < 1 || value > 5;
					const rating_score = isIncorrectValue ? 5 : Number(value);
					const ratingInput = document.getElementById('rating');

					if (!ratingInput) {
						return;
					}

					ratingInput.dataset.value = value;
					ratingInput.value = rating_score;

					return;
				default:
					return;
			}
		}
	}

	if (!button) {
		return;
	}

	const { dataset } = button;

	for (const action in actions) {
		if (dataset.hasOwnProperty(action)) {
			actions[action](dataset);
		}
	}
}

const reviewRatingButtons = getReviewRatingButtons();
let selectedRatingButton = null;

if (reviewRatingButtons.length) {
	reviewRatingButtons.forEach(button => {
		button.parentElement.addEventListener('mouseenter', (e) => updateReviewRating(e.target.firstElementChild));
		button.parentElement.addEventListener('mouseleave', () => updateReviewRating(selectedRatingButton));
		button.addEventListener('click', (e) => {
			selectedRatingButton = e.currentTarget;
			updateReviewRating(selectedRatingButton);
		});
	})
}

function getReviewRatingButtons () {
	return Array.from(document.querySelectorAll('button[data-set-input="rating"]'));
}

function updateReviewRating (button) {
	const listButtonElements = getReviewRatingButtons();
	const selectedClassName = 'selected';
	const index = button ? listButtonElements.findIndex(listButton => listButton === button) : -1;

	listButtonElements.forEach((listButton, idx) => {
		if (idx <= index) {
			addClassToElement(listButton, selectedClassName);
		} else {
			removeClassFromElement(listButton, selectedClassName);
		}
	});
}

// TODO reviews json file and load reviews from file;

}init();